import { Wallets } from '../Wallets/Wallets';

export const PageContent = () => {
    return <Wallets />;
};

PageContent.displayName = 'PageContent';
